import { render, staticRenderFns } from "./RelatorioParcela.vue?vue&type=template&id=35d06a16"
import script from "./RelatorioParcela.vue?vue&type=script&lang=js"
export * from "./RelatorioParcela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports